import { render, staticRenderFns } from "./SimForm.vue?vue&type=template&id=2d6359b8&scoped=true"
import script from "./SimForm.vue?vue&type=script&lang=js"
export * from "./SimForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6359b8",
  null
  
)

export default component.exports